// extracted by mini-css-extract-plugin
export default {"outlet":"OutletPainel_outlet__8jLQV"};